export default __webpack_public_path__ + "static/media/logo.fc86d26d.svg";